import { useThree } from "@react-three/fiber";
import React, { useEffect, useRef } from "react";
import { OrbitControls } from "three-stdlib";

export default function OrbitControlsComponent({ initialPosition }: { initialPosition: number[] }) {
  const { camera, gl } = useThree();

  // useThree(({ camera }) => {
  //   // camera.position.set(-150, 0, 0);
  //   // camera.rotation.set(90, 0, 0);
  // });
  useEffect(() => {
    const controls = new OrbitControls(camera, gl.domElement);
    // camera.position.set(-250, 0, 0);
    // controls.minDistance = 3;
    // controls.maxDistance = 20;
    // controls.position0.set(100, 200, 0);
    return () => {
      controls.dispose();
    };
  }, [camera, gl]);

  useEffect(() => {
    camera.position.set(initialPosition[0], initialPosition[1], initialPosition[2]);
    camera.lookAt(0, 0, 0);
  }, []);

  return null;
}
